// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Type_Header = require("../../type/Type_Header.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../particle/Particle_Spacer_Ds.bs.js");
var Particle_Background_Ds = require("../particle/Particle_Background_Ds.bs.js");

var header_blockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("Zero", "S", undefined));

var header_height = Type_Header.Constants.heightStyle;

var header_borderStyle = {
  active: /* Header */17,
  inactive: /* Header */17,
  focus: /* Accessibility */0,
  line: /* BurgerMenuLine */2
};

var header_width = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
      NAME: "px",
      VAL: 55
    });

var header = {
  background: Particle_Background_Ds.dropdownMenu,
  blockSpace: header_blockSpace,
  height: header_height,
  borderStyle: header_borderStyle,
  width: header_width
};

var corporate_background = Particle_Background_Ds.Corporate.menu;

var corporate_blockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("Zero", "S", undefined));

var corporate_height = Type_Header.Constants.heightStyle;

var corporate_borderStyle = {
  active: /* CorporateBurgerMenu */4,
  inactive: {
    TAG: /* Cta */2,
    _0: /* Inactive */1,
    _1: "Medium"
  },
  focus: /* CorporateAccessibility */3,
  line: /* CorporateBurgerMenuLine */5
};

var corporate_width = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
      NAME: "px",
      VAL: 60
    });

var corporate = {
  background: corporate_background,
  blockSpace: corporate_blockSpace,
  height: corporate_height,
  borderStyle: corporate_borderStyle,
  width: corporate_width
};

var presse_background = Particle_Background_Ds.Presse.menu;

var presse_blockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("Zero", "XXS", undefined));

var presse_height = Type_Header.Constants.heightStyle;

var presse_borderStyle = {
  active: /* PresseBurgerMenu */20,
  inactive: {
    TAG: /* Cta */2,
    _0: /* Inactive */1,
    _1: "Medium"
  },
  focus: /* Accessibility */0,
  line: /* PresseBurgerMenuLine */21
};

var presse_width = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
      NAME: "px",
      VAL: 40
    });

var presse = {
  background: presse_background,
  blockSpace: presse_blockSpace,
  height: presse_height,
  borderStyle: presse_borderStyle,
  width: presse_width
};

function view(param) {
  return {
          background: param.background,
          blockSpace: param.blockSpace,
          height: param.height,
          borderStyle: param.borderStyle,
          width: param.width
        };
}

exports.header = header;
exports.corporate = corporate;
exports.presse = presse;
exports.view = view;
/* header Not a pure module */
